const searchFormValue = {
    search: null,
};

const operatorOptions = [
    { text: '선택해주세요.', value: null, disabled: true },
    { text: 'AND (모든 조건 만족)', value: 'AND' },
    { text: 'OR (하나 이상 조건 만족)', value: 'OR' },
];

const columns = [
    {
        key: 'index',
        label: '번호',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'name',
        label: '규칙 그룹명',
        thStyle: {
            width: '200px'
        },
        thClass: ['mb-0','th-left'],
        tdClass: ['td-left', 'text-truncate'],
    },
    {
        key: 'conditions',
        label: '조건',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'child_groups',
        label: '자식 그룹',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'operator',
        label: '연산자',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'detail',
        label: '상세',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'updated_at',
        label: '수정일시',
        thStyle: {
            width: '160px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
];

export { searchFormValue, columns, operatorOptions};
